import { render, staticRenderFns } from "./InboxListAssigned.vue?vue&type=template&id=56f52e4d"
import script from "./InboxListAssigned.vue?vue&type=script&lang=js"
export * from "./InboxListAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports